module.exports = __webpack_public_path__ + "swipper-1.png?c286e2edb01906844a6d0a728827e3f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swipper-1.png
// module id = 229
// module chunks = 0